define('modules/start/products/automation/logobutton/view',['require','exports','module','env','../../base/logobutton/view','ldsh!./template'],function(require, exports, module) {
    'use strict';

    var Config = require('env');
    var BaseView = require('../../base/logobutton/view');
    var productName = 'automation';
    var Layout = BaseView.extend({
        template: require('ldsh!./template'),
        privateUrl: Config.automationUrl,
        defaultDomain: Config.defaultDomain,
        serviceName: productName,
        requestStatus: false,

        events: {
            'click .redirect-btn': 'redirect'
        },

        initialize: function () {},

        serialize: function () {
            return {
                logoName: 'automation',
                listDetails: this.listDetails,
                requestStatus: this.requestStatus
            };
        },

        redirect: function () {
            window.location = this.privateUrl + '/?company_id=' + this.companyId;
        }
    });

    module.exports = Layout;
});

